import React from 'react';
import { Redirect } from 'react-router-dom';
import { Route } from '@simple-contacts/react-router-async-routes';
import { dominioDemandaCirurgica } from './config/database';
import packageJson from '../package.json';

let rota_redireciona = '/auth/login';
let ultimaVersaoOpera = '00.00.00';

const isAllowed = token => {
  return token !== null && token !== undefined && token !== 'N';
};

let profissional = JSON.parse(localStorage.getItem('profissional'));

export const getRedirectPath = () => {
  if (isAllowed(profissional?.acessoSalasCirurgicas)) return '/admin/mapaDeSalas';
  if (isAllowed(profissional?.acessoMeusPedidos)) return '/admin/meusPedidos';
  if (isAllowed(profissional?.acessoDemandaMedico)) return '/admin/minhasDemandas';
  if (isAllowed(profissional?.acessoPedidosCirurgia)) return '/admin/pedidosCirurgia';
  if (isAllowed(profissional?.acessoChecklistGeral)) return '/admin/checkListGeral';
  if (isAllowed(profissional?.acessoParecerAreaTecnica)) return '/admin/pareceresAreaTecnica';
  if (isAllowed(profissional?.acessoPedidosCirurgia)) return '/admin/pedidosResidentes';
  if (isAllowed(profissional?.acessoAgendaAreaTecnica)) return '/admin/agendaAreaTecnica';
  if (isAllowed(profissional?.acessoDashBoard)) return '/admin/dashboard';
  if (isAllowed(profissional?.acessoAgendaMedico)) return '/admin/agendaMedico';
  if (isAllowed(profissional?.acessoTodasDemandas)) return '/admin/demandas';
  if (isAllowed(profissional?.acessoRelatorios)) return '/admin/relatorioDemandaCirurgica';
  localStorage.clear();
  return '/auth';
};

const getUltimaVersaoOpera = async () => {
  return dominioDemandaCirurgica.get('/api/versaoOpera').then(res => {
    ultimaVersaoOpera = res.data.versao;
  });
};

export const isAuthenticated = props => {
  const auth = localStorage.getItem('profissional');
  if (auth == null) return false;
  profissional = JSON.parse(localStorage.getItem('profissional'));

  if (ultimaVersaoOpera !== packageJson.version) {
    rota_redireciona = '/auth/avisoAtualizacaoOpera';
    return false;
  }
  if (props.location.pathname.includes('dashboard') && !isAllowed(profissional.acessoDashBoard)) {
    rota_redireciona = getRedirectPath();
    return false;
  }
  if (
    props.location.pathname.includes('mapaDeSalas') && !isAllowed(profissional.acessoSalasCirurgicas)){
    rota_redireciona = getRedirectPath();
    return false;
    }
  if (
    props.location.pathname.includes('meusPedidos') &&
    !isAllowed(profissional.acessoMeusPedidos)
  ) {
    rota_redireciona = getRedirectPath();
    return false;
  }
  if (
    props.location.pathname.includes('minhasDemandas') &&
    !isAllowed(profissional.acessoDemandaMedico)
  ) {
    rota_redireciona = getRedirectPath();
    return false;
  }
  if (
    props.location.pathname.includes('pedidosResidentes') &&
    !isAllowed(profissional.acessoPedidosResidentes)
  ) {
    rota_redireciona = getRedirectPath();
    return false;
  }
  if (
    props.location.pathname.includes('pedidosCirurgia') &&
    !isAllowed(profissional.acessoPedidosCirurgia)
  ) {
    rota_redireciona = getRedirectPath();
    return false;
  }
  if (
    props.location.pathname.includes('checkListGeral') &&
    !isAllowed(profissional.acessoChecklistGeral)
  ) {
    rota_redireciona = getRedirectPath();
    return false;
  }
  if (
    props.location.pathname.includes('pareceresAreaTecnica') &&
    !isAllowed(profissional.acessoParecerAreaTecnica)
  ) {
    rota_redireciona = getRedirectPath();
    return false;
  }
  if (
    props.location.pathname.includes('agendaAreaTecnica') &&
    !isAllowed(profissional.acessoAgendaAreaTecnica)
  ) {
    rota_redireciona = getRedirectPath();
    return false;
  }
  if (
    props.location.pathname.includes('agendaMedico') &&
    !isAllowed(profissional.acessoAgendaMedico)
  ) {
    rota_redireciona = getRedirectPath();
    return false;
  }
  if (
    props.location.pathname.includes('demandas') &&
    !isAllowed(profissional.acessoTodasDemandas)
  ) {
    rota_redireciona = getRedirectPath();
    return false;
  }
  if (
    props.location.pathname.includes('relatorioDemandaCirurgica') &&
    !isAllowed(profissional.acessoRelatorios)
  ) {
    rota_redireciona = getRedirectPath();
    return false;
  }

  return true;
};

const updateConfigs = async () => {
  return dominioDemandaCirurgica.get('/api/configuracoes').then(
    res => {
      localStorage.setItem('configuracoes', JSON.stringify(res.data));
    },
    () => { }
  );
};

const updateSystemConfigs = async () => {
  return dominioDemandaCirurgica.get('/api/configuracoesRecursoSistema').then(
    res => {
      localStorage.setItem('configuracoesRecursoSistema', JSON.stringify(res.data));
    },
    () => { }
  );
};

export const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      async
      {...rest}
      render={props => {
        return updateConfigs()
          .then(() => updateSystemConfigs())
          .then(() => getUltimaVersaoOpera())
          .then(() =>
            isAuthenticated(props) ? (
              <Component {...props} />
            ) : (
              <Redirect to={{ pathname: rota_redireciona, state: { from: props.location } }} />
            )
          );
      }}
    />
  );
};
